import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CardModule } from '@modules/card/card.module';
import { SharedModule } from '@modules/shared/shared.module';
import { NgxMasonryModule } from 'ngx-masonry';

import { ArticleGalleryComponent } from './article-gallery/article-gallery.component';
import { ArticleStatusBarComponent } from './article-status-bar/article-status-bar.component';
import { ArticleComponent } from './article.component';
import { ExpandableCopyComponent } from './expandable-copy/expandable-copy.component';
import { MasonryGalleryComponent } from './masonry-gallery/masonry-gallery.component';

@NgModule({
  declarations: [
    ArticleComponent,
    ExpandableCopyComponent,
    ArticleStatusBarComponent,
    ArticleGalleryComponent,
    MasonryGalleryComponent,
  ],
  exports: [
    ArticleComponent,
    ExpandableCopyComponent,
    ArticleStatusBarComponent,
    ArticleGalleryComponent,
    MasonryGalleryComponent,
  ],
  imports: [CommonModule, SharedModule, CardModule, NgxMasonryModule, RouterModule],
})
export class ArticleModule {}
